<template>
  <Teleport to="body">
    <BaseModal
      :show="isOpen"
      size="sm"
      @close="onCancel"
    >
      <div class="p-6">
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ options?.title }}
        </h2>
        <p class="text-gray-600 dark:text-gray-300 mt-2">
          {{ options?.message }}
        </p>

        <div class="flex justify-end gap-2 mt-6">
          <button
            type="button"
            class="px-4 py-2 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-100 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-500 cursor-pointer"
            @click="onCancel"
          >
            {{ options?.cancelText }}
          </button>
          <button
            type="button"
            class="px-4 py-2 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer"
            :class="options?.confirmClass"
            @click="onConfirm"
          >
            {{ options?.confirmText }}
          </button>
        </div>
      </div>
    </BaseModal>
  </Teleport>
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { useConfirm } from '@/composables/useConfirm'
import BaseModal from '@/components/common/BaseModal.vue'

const { isOpen, options, onConfirm, onCancel } = useConfirm()

watch(isOpen, (newValue) => {
  console.log('ConfirmationDialog isOpen changed:', newValue)
})

watch(options, (newValue) => {
  console.log('ConfirmationDialog options changed:', newValue)
})
</script>
